import amariPic from "@/public/images/artists/amari.png";
import { Artist } from "@/types/types";

export const amari = {
  id: "296",
  name: "Amari",
  image: amariPic,
  description: `Amari has a soft but expressive voice with a dusky tone, light grain, and easy delivery.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Famari-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Afrobeat", "RnB", "Pop"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 46,
        high: 66,
      },
      sweetSpot: 57,
    },
  },
} as const satisfies Artist;
